import { memo, useCallback, useEffect, useState } from 'react';
import { Bar, BarChart, Cell } from 'recharts';
import { Flow } from '@thive/fddm-types';

import { theme } from '@/modules/common/theme';
import { MAX_ORDER_PROFILE_HOURS } from '@/modules/common/constants/orderProfile';

type Props = {
  hourlyOrderCounts: Flow['hourlyOrderCounts'];
};

type ChartData = { hour: number; orderCount: number };

function FlowGraphComponent({ hourlyOrderCounts }: Props) {
  const [chartData, setChartData] = useState<ChartData[]>([]);
  const [focusBar, setFocusBar] = useState<number | null>(null);

  const prepareChartData = useCallback(
    async (counts: number[]) => {
      // pad with 0 loads
      if (counts.length < MAX_ORDER_PROFILE_HOURS) {
        const padCount = MAX_ORDER_PROFILE_HOURS - counts.length;
        for (let i = 0; i < padCount; ++i) {
          counts.push(0);
        }
      } else if (counts.length > MAX_ORDER_PROFILE_HOURS) {
        counts = counts.slice(0, MAX_ORDER_PROFILE_HOURS);
      }

      setChartData(
        counts.map((orderCount, index) => ({
          hour: index + 1,
          orderCount,
        })),
      );
    },
    [setChartData],
  );

  useEffect(() => {
    const slicedProfile = hourlyOrderCounts.slice(0, MAX_ORDER_PROFILE_HOURS);
    // plz fix me
    // eslint-disable-next-line react-hooks/set-state-in-effect
    prepareChartData(slicedProfile);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hourlyOrderCounts]);

  return (
    <BarChart
      width={150}
      height={50}
      data={chartData}
      onMouseMove={(state) => {
        if (!state?.activeTooltipIndex && state?.activeTooltipIndex !== 0) {
          setFocusBar(null);
        } else {
          setFocusBar(state.activeTooltipIndex);
        }
      }}
      onMouseLeave={() => setFocusBar(null)}
      style={{ marginTop: '-5px' }}
    >
      <Bar dataKey='orderCount'>
        {chartData.map((entry, index) => (
          <Cell
            key={entry.hour}
            fill={focusBar === index ? theme.palette.primary.main : theme.palette.neutral.lighter}
          />
        ))}
      </Bar>
    </BarChart>
  );
}

export const FlowGraph = memo(FlowGraphComponent);
